<template>
    <div class="p-10">
        <div class="row">
            <div class="col-12">
                <div class="card-body">
                    <h4 class="card-title">You are the owner of this {{offer.type | lowercase}} offer</h4>

                    <h2 class="font-medium m-t-40 m-b-0">{{offer.commodity}}</h2>
                    <span class="text-muted">{{offer.description}}</span>

                    <h2 class="font-medium m-t-40 m-b-0">{{offer.quantity | count}} {{offer.unit.symbol}}</h2>
                    <span class="text-muted">Available Quantity</span>

                    <h2 class="font-medium m-t-40 m-b-0">{{offer.unit_price | money}} / {{offer.unit.symbol}}</h2>
                    <span class="text-muted">Unit Price</span>

                    <div class="m-t-30 m-b-30">
                        <router-link :to="{name: 'editoffer', params: {offerid: offer.offer_id}}" class="btn btn-lg btn-success text-white waves-effect waves-light">
                            Edit Offer
                        </router-link>
                    </div>
                </div>
                <div>
                    <hr>
                </div>
                <div class="card-body">
                    <h4 class="card-title"><i class="fa fa-lock"></i>&nbsp;Encrypted Negotiations</h4>
                    <blockquote>
                        Once you open a trade, messages are end-to-end encrypted so your privacy is protected. The only case where we can read your messages is if either party initiates a dispute.
                    </blockquote>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OfferSidebar",
        props: {
            offerid: String,
            offer: Object
        },
        data() {
            return {
                openTradeModal: false,
            };
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>